export default "__VITE_ASSET__DbNE2itS__"